module.exports = __webpack_public_path__ + "img/fire.735abb65.png";